var render = function render(){var _vm=this,_c=_vm._self._c;return _c('OrderOverviewPage',{attrs:{"i18n-prefix":"takeawayOrder","config-key":"TAKEAWAY_ORDER","retrieve-order-options":_vm.retrieveOrderOptions}})
}
var staticRenderFns = []

export { render, staticRenderFns }